import React from 'react';
import { I18nProvider } from '@bingads-webui/copilot-i18n';
import { CopilotRepositoryContext } from './CopilotRepositoryContext';
import { useCopilotRepository } from '../../hooks/index';
import { IPerfMarker, IServerContext, RecommendationType } from '../../types';

interface ICopilotRepositoryProviderProps {
  campaignId?: number,
  children: React.ReactNode,
  finalUrl: string,
  locale?: string,
  perfMarker?: IPerfMarker,
  recommendationType: RecommendationType,
  serverContext: IServerContext,
  enableLogoAndCTA?: boolean,
  useClipchamp?: boolean,
}

export const CopilotRepositoryProvider: React.FC<ICopilotRepositoryProviderProps> = React.memo(({
  campaignId,
  children,
  finalUrl,
  locale,
  perfMarker,
  recommendationType,
  serverContext,
  enableLogoAndCTA,
  useClipchamp,
}) => {
  const hookResult = useCopilotRepository(serverContext, campaignId!, finalUrl, recommendationType, perfMarker, enableLogoAndCTA, useClipchamp);

  return (
    <CopilotRepositoryContext.Provider value={campaignId ? hookResult : undefined}>
      <I18nProvider locale={locale}>
        {children}
      </I18nProvider>
    </CopilotRepositoryContext.Provider>
  );
});
